export default {
  online_payments_off:
    'A entrega está ativada, mas os clientes não a podem encomendar: a entrega por estafeta é paga apenas online e os pagamentos online estão desativados.',
  gateway_not_verified:
    'A entrega está ativada, mas os clientes não a podem encomendar: a entrega por estafeta é paga apenas online e os pagamentos online estão em pausa até a sua conta de pagamento ser verificada.',
  stripe_processing_fee_missing:
    'A entrega está ativada, mas os clientes não a conseguem encomendar: a entrega por estafeta só é paga online e os pagamentos online estão suspensos até o seu parceiro definir a respetiva taxa de processamento.',
  turn_on_online_payments: 'Ativar pagamentos online',
};
